<template>

    <div v-if="download">
        <q-item class="q-px-none q-pt-none q-pb-md">
            <q-item-section>
                <q-item-label top lines="1" class="text-h6 text-weight-medium">
                    <span>{{ download.title }}</span>
                </q-item-label>
                <q-item-label caption lines="1">
                    <span>File Size: {{ download.fileSize }}</span>
                </q-item-label>
                <q-item-label caption lines="1">
                    <span>Date: {{ download.releaseDate | date }}</span>
                </q-item-label>
                <q-item-label v-if="download.versionText" caption lines="1">
                    <span>Version: {{ download.versionText }}</span>
                </q-item-label>
            </q-item-section>
        </q-item>
        <div>

            <q-form @submit="onSubmit"
                    autocomplete="off"
                    class="q-gutter-y-md column">
                <div class="q-mt-xs row q-col-gutter-md">
                    <div class="col-xs-12 col-sm-6">
                        <q-input v-model.trim="form.firstName"
                                 label="First Name"
                                 autocomplete="on" name="firstName"
                                 :rules="[ val => $v.form.firstName.required || 'First name is required' ]"
                                 outlined dense
                                 hide-bottom-space>
                            <template v-slot:prepend>
                                <q-icon name="mdi-account" />
                            </template>
                        </q-input>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <q-input v-model.trim="form.lastName"
                                 label="Last Name"
                                 autocomplete="on" name="lastName"
                                 :rules="[ val => $v.form.lastName.required || 'Last name is required' ]"
                                 outlined dense
                                 hide-bottom-space>
                        </q-input>
                    </div>
                </div>

                <q-input v-model.trim="form.email"
                         label="Email"
                         autocomplete="on" name="email"
                         :rules="[ val => $v.form.email.required || 'Email is required', val => $v.form.email.email || 'Not a valid email format' ]"
                         outlined dense
                         hide-bottom-space>
                    <template v-slot:prepend>
                        <q-icon name="mdi-email" />
                    </template>
                </q-input>
                <q-input v-model.trim="form.phone"
                         label="Phone"
                         autocomplete="on" name="phone"
                         outlined dense
                         hide-bottom-space>
                    <template v-slot:prepend>
                        <q-icon name="mdi-phone" />
                    </template>
                </q-input>

                <q-input v-model.trim="form.company"
                         label="Company"
                         autocomplete="on" name="company"
                         outlined dense
                         hide-bottom-space>
                    <template v-slot:prepend>
                        <q-icon name="mdi-domain" />
                    </template>
                </q-input>
                <q-list v-if="oem && download.authorizeInfoToOEM">
                    <q-item class="q-pa-none">
                        <q-item-section avatar top>
                            <q-checkbox v-model="form.consent" @input="$v.$reset()" />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label class="text-left">
                                <q-field :value="form.consent"
                                         :rules="[ val => $v.form.consent.sameAs || 'To download this software you must first consent to the collection and use of your information as described here.' ]"
                                         no-error-icon
                                         class="text-caption text-black"
                                         borderless dense
                                         hide-bottom-space>

                                    <span class="text-black cursor-pointer" @click="form.consent = !form.consent">By checking this box, I hereby consent to Avenir's collection of my personal information for the purpose of allowing Avenir and its third party partner ({{ oem.name }}) to track the current user base of the software and to communicate with me regarding their products and services. I further consent to Avenir disclosing such information to the relevant third party partner for the purpose described above.</span>
                                </q-field>
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
                <div>
                    <q-btn :loading="loading"
                           :color="downloadFilePending ? '' : 'positive'" type="submit"
                           :disabled="!download || progress[download.id] > 0" class="full-width" style="padding-top: 0.15em; padding-bottom: 0.15em" dense>
                        <q-icon v-show="!downloadFilePending"
                                name="mdi-download"
                                class="on-left" />

                        <span v-show="!downloadFilePending">Download Now</span>
                    </q-btn>
                </div>
            </q-form>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { sameAs, required, email } from 'vuelidate/lib/validators'

    export default {
        name: 'download-form',
        props: {
            download: Object,
            oem: Object,
        },
        data() {
            return {
                progress: {},
                loading: false,
                form: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    company: '',
                    consent: false,
                }
            }
        },
        validations() {
            if (this.download.authorizeInfoToOEM) {
                return {
                    form: {
                        firstName: { required },
                        lastName: { required },
                        email: { required, email },
                        consent: {
                            required,
                            sameAs: sameAs(() => true),
                        },
                    }
                }
            } else {
                return {
                    form: {
                        firstName: { required },
                        lastName: { required },
                        email: { required, email },
                    }
                }
            }
        },
        methods: {
            onSubmit() {
                this.$v.form.$touch()
                if (this.$v.form.$pending || this.$v.form.$error) return
                this.serveDownload()
                this.postBenchmarkEmail()
            },
            serveDownload() {

                this.loading = true

                var payload = {
                    name: this.form.firstName + ' ' + this.form.lastName,
                    email: this.form.email,
                    phone: this.form.phone,
                    company: this.form.company,
                    authorizeInfoToOEM: this.download.authorizeInfoToOEM,
                    productLineID: this.download.productLineID,
                    productTitle: this.download.title,
                    productDescription: this.download.description,
                    productVersion: this.download.versionText,
                }

                this.$store.dispatch('postDownloadLog', payload)
                this.downloadFile(this.download.filePath)

                setTimeout(() => {
                    this.loading = false
                }, 5000); // 5 Second timeout to make sure the user cannot double click the Download button adding duplicate download logs

            },
            postBenchmarkEmail() {

                const payload = {
                    email: this.form.email,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    prodCatID: this.download.productCategoryID
                }

                this.$store.dispatch('submitDownloadContactToBenchmark', payload)

            },
            syncForm() {
                if (this.getAccountInfoData) {
                    this.form.email = this.getAccountInfoData.email
                    this.form.firstName = this.getAccountInfoData.firstName
                    this.form.lastName = this.getAccountInfoData.lastName
                    this.form.company = this.getAccountInfoData.company
                    this.form.phone = this.getAccountInfoData.phone
                }
            },
            getAccountInfo() {
                this.$store.dispatch('getAccountInfoByEmail', this.user.username).then(() => {
                    this.syncForm()
                })
            },
        },
        computed: {
            ...mapState([
                'downloadFileData',
                'downloadFilePending',
                'getAccountInfoPending',
                'getAccountInfoData',
            ]),
            user() { return this.$store.getters.authUser },
        },
        mounted() {
            if (this.user)
                this.getAccountInfo()
        },
        watch: {
            getAccountInfoData(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.syncForm()
                }
            },
        }

    }
</script>
